import axios from '@/utils/request';

// 获取标签
export const getTags = (data: any) => {
  return axios.request({
    url: 'Tag/GetTags',
    method: 'GET',
    params: data,
  });
};
